import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthAccessProvider } from "app/core/core.auth";
import {
  AnomalyType,
  AnomalyTypeResponse,
  BaseComponent,
  DetailAnomlieResponse,
  User,
  UserContext,
  UserData
} from "app/core/core.component";
import { AnomalieService } from "app/service/anomalie.service";
import { BusyProvider } from "app/service/busy.service";
import { MessageProvider } from "app/service/message.service";
import { Message } from "primeng/components/common/api";
import { Subscription } from 'rxjs/Subscription';
import { forkJoin } from 'rxjs/observable/forkJoin';

declare var $: any;

@Component({
  selector: "app-anomalie-user-setting",
  templateUrl: "./anomalie-user-setting.component.html",
  styleUrls: ["./anomalie-user-setting.component.css"]
})
export class AnomalieUserSettingComponent
  extends BaseComponent
  implements OnInit, OnDestroy {
  static DIALOG_ID = "AnomalieDialog";

  userContext: UserContext;
  user: User;
  userData = new UserData();
  errorMessage: string;
  validationMessage: string;
  loading = false;

  msgs: Message[] = [];

  userAnomalie: DetailAnomlieResponse = null;
  allAnomalie: AnomalyType[] = [];
  anomalieToUpdate: boolean[] = [];
  blockToUpdate: boolean[] = [];
  checkboxAnomalieMap: Record<string, boolean> = {};
  checkboxBloccantiMap: Record<string, boolean> = {}; ù

  private subscriptions: Subscription[] = [];

  constructor(
    protected authAccess: AuthAccessProvider,
    protected router: Router,
    protected messageProvider: MessageProvider,
    private anomalieService: AnomalieService,
    private busyProvider: BusyProvider
  ) {
    super(authAccess, router, messageProvider);
  }

  ngOnInit() {
    this.userContext = this.authAccess.getUserContext();
    if (!this.userContext) {
      this.authAccess.invalidate();
      return;
    }

    const statusSub = this.anomalieService
      .anomalieComponentStatus$
      .subscribe((u: User) => {
        if (!u) return;
        this.user = u;
        $("#" + AnomalieUserSettingComponent.DIALOG_ID)
          .modal({ backdrop: "static", keyboard: false });

        const combined = forkJoin([
          this.anomalieService.getAnomalieUserStatus(
            this.userContext.srmToken, u.id
          ),
          this.anomalieService.getAnomalyTypes(this.userContext.srmToken)
        ]);

        const forkSub: Subscription = combined
          .subscribe(res => {
            const [userRes, allRes] = res as [
              DetailAnomlieResponse,
              AnomalyTypeResponse
            ];

            this.userAnomalie = userRes;
            this.allAnomalie = allRes.anomalyTypes;
            this.initCheckboxMap();

            this.allAnomalie.sort((a1, a2) => {
              if (a1.priority == a2.priority) {
                return a1.id > a2.id ? 1 : -1;
              }
              return a1.priority > a2.priority ? 1 : -1;
            });
          },
            err => this.handleError(err)
          );

        this.subscriptions.push(forkSub);
      });

    this.subscriptions.push(statusSub);
  }

  ngOnDestroy() {
    for (const sub of this.subscriptions) {
      sub.unsubscribe();
    }
  }

  close() {
    $("#" + AnomalieUserSettingComponent.DIALOG_ID).modal("hide");
    this.resetState();
  }

  save() {
    for (const key in this.checkboxAnomalieMap) {
      this.anomalieToUpdate.push(this.checkboxAnomalieMap[key]);
    }
    for (const key in this.checkboxBloccantiMap) {
      this.blockToUpdate.push(this.checkboxBloccantiMap[key]);
    }
    this.busyProvider.showBusyIndicator();

    this.anomalieService.updateAnomalieUtenteStatus(this.userContext.srmToken, this.user.id, this.anomalieToUpdate, this.blockToUpdate).subscribe(
      response => {
        this.busyProvider.hideBusyIndicator();
        console.log('Risposta dal server:', response);
        this.msgs = [];
        this.msgs.push({ severity: 'success', summary: 'OK', detail: 'Anomalie aggiornate con successo' });
      },
      error => {
        console.error('Errore durante l\'update:', error);
        this.busyProvider.hideBusyIndicator();
        this.handleError(error);
      });
    this.anomalieToUpdate = [];
    this.blockToUpdate = [];
  }

  private resetState() {
    this.user = null;
    this.userData = new UserData();
    this.errorMessage = null;
    this.validationMessage = null;
    this.loading = false;
    this.userAnomalie = null;
    this.allAnomalie = [];
    this.checkboxAnomalieMap = {};
    this.anomalieToUpdate = [];
    this.blockToUpdate = [];
  }

  onChangeAnomalia(id: string) {
    if (this.checkboxAnomalieMap[id] == null) {
      this.checkboxAnomalieMap[id] = true;
    } else {
      this.checkboxAnomalieMap[id] = !this.checkboxAnomalieMap[id];
    }
  }

  private initCheckboxMap(): void {
    this.checkboxAnomalieMap = {};

    let i = 0;

    for (const a of this.allAnomalie) {
      this.checkboxAnomalieMap[a.id] = this.userAnomalie.anomalie[i] ? true : false;
      this.checkboxBloccantiMap[a.id] = this.userAnomalie.bloccanti[i] ? true : false;
      i++;
    }
  }

  removeAll() {
    for (const key in this.checkboxAnomalieMap) {
      this.checkboxAnomalieMap[key] = false;
    }
    for (const key in this.checkboxBloccantiMap) {
      this.checkboxBloccantiMap[key] = false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/anomalies-user-setting/anomalie-user-setting.component.ts